const TenantAPI = process.env.NEXT_PUBLIC_API_URL;
import API from "../API";
export async function TenantCustomDomainAPI(hostname) {
  const removeWWW = hostname?.replace("www.", "");
  const res = await fetch(TenantAPI + `/common/custom-domain/${removeWWW}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("TenantCustomDomainAPI", data);
      return data;
    });

  return res;
}

export const GetWebsiteDetailsApi = async () => {
  try {
    const response = await API.get(`/common/website/tenant`);
    return response;
  } catch (error) {
    throw error;
  }
};

let cachedWebsiteDetailsPromise;

export const GetCachedWebsiteDetailsApi = async () => {
  if (!cachedWebsiteDetailsPromise) {
    cachedWebsiteDetailsPromise = GetWebsiteDetailsApi().catch((error) => {
      cachedWebsiteDetailsPromise = undefined;
      throw error;
    });
  }

  return cachedWebsiteDetailsPromise;
};

export const GetCompanyDetailsApi = async () => {
  try {
    const response = await API.get(`/common/api/companydetails`);
    return response;
  } catch (error) {
    throw error;
  }
};

let cachedCompanyDetailsPromise;

export const GetCachedCompanyDetailsApi = async () => {
  if (!cachedCompanyDetailsPromise) {
    cachedCompanyDetailsPromise = GetCompanyDetailsApi().catch((error) => {
      cachedCompanyDetailsPromise = undefined;
      throw error;
    });
  }

  return cachedCompanyDetailsPromise;
};



export const GetGeneralTokenApi = async () => {
  try {
    const response = await API.get(`/ecommerce/generate/guest-token`);
    return response;
  } catch (error) {
    throw error;
  }
};




